var React = require('react');

function PFFBrandIconsSocialSharingEmail (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#9D9D9F;}\n"),React.createElement("g",{"key":1},[React.createElement("polygon",{"className":"st0","points":"546,278.5 360,410.3 174,278.5 174,469.5 546,469.5 \t","key":0}),React.createElement("polygon",{"className":"st0","points":"542.1,244.5 177.9,244.5 360,373.5 \t","key":1}),React.createElement("path",{"className":"st0","d":"M360,0C161.2,0,0,161.2,0,360s161.2,360,360,360s360-161.2,360-360S558.8,0,360,0z M576,499.5H144v-285h432\n\t\tV499.5z","key":2})])]);
}

PFFBrandIconsSocialSharingEmail.defaultProps = {"version":"1.1","id":"Icon","x":"0px","y":"0px","viewBox":"0 0 720 720","style":{"enableBackground":"new 0 0 720 720"},"xmlSpace":"preserve"};

module.exports = PFFBrandIconsSocialSharingEmail;

PFFBrandIconsSocialSharingEmail.default = PFFBrandIconsSocialSharingEmail;
